import { containerWithGutters, theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

export const root = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};

  ul {
    display: flex;
    margin: 0;
    border-bottom: 2px solid var(--neutral-black-10);
    ${containerWithGutters};
    list-style: none;
    column-gap: ${spacing.xl}px;
  }

  li {
    ${responsiveText.BODY.MD};

    & > a {
      display: block;
      padding: ${spacing.sm}px 0;
      text-decoration: none;
      color: var(--neutral-black-base);

      &:hover:not([aria-current='page']) {
        margin-bottom: -2px;
        border-bottom: 2px solid var(--neutral-black-40);
      }

      &[aria-current='page'] {
        margin-bottom: -2px;
        border-bottom: 2px solid var(--brand-purple-base);
        color: var(--brand-purple-base);
      }
    }
  }
`;
